export function longpress(node, duration = 500) {
  let timer;
  let interval;

  const handleMousedown = () => {
    timer = setTimeout(() => {
      node.addEventListener("mousemove", handleMousemove, true);
      node.addEventListener("touchmove", handleMousemove, true);
      interval = setInterval(
        () => node.dispatchEvent(new CustomEvent("longpressstart")),
        50
      );
    }, duration);
  };

  const handleMouseup = () => {
    clearTimeout(timer);
    clearInterval(interval);
    node.removeEventListener("mousemove", handleMousemove, true);
    node.removeEventListener("touchmove", handleMousemove, true);
  };

  const handleMousemove = () => {
    clearTimeout(timer);
    clearInterval(interval);
    node.removeEventListener("mousemove", handleMousemove, true);
    node.removeEventListener("touchmove", handleMousemove, true);
  };

  node.addEventListener("mousedown", handleMousedown, true);
  node.addEventListener("mouseup", handleMouseup, true);
  node.addEventListener("touchstart", handleMousedown, true);
  node.addEventListener("touchend", handleMouseup, true);
  return {
    destroy() {
      node.removeEventListener("mousedown", handleMousedown, true);
      node.removeEventListener("mouseup", handleMouseup, true);
    },
  };
}
